import { useQuery } from "@tanstack/react-query";
import { axios } from "./axios";
import { useAuth } from "../context/AuthContext";
import { useNavigate } from "react-router-dom";
import { ROUTE } from "../routes";
import { env } from "../utils/env";
import { AccessRole } from "../types/AccessRole";

const fetchAccessRoles = (authHeader: string) => () =>
  axios.get<AccessRole[]>(`${env.verifyServiceUrl}user/access_role/`, {
    headers: {
      Authorization: authHeader,
    },
  });

/**
 * Roles table for Settings > Account & Access > Roles & Permissions
 * (SEG-S021, Phase 1 — read-only). Response envelope (bare array vs the
 * `{results}` pagination shape) isn't confirmed against the real schema
 * yet — read it via `unwrapList` rather than assuming one shape.
 */
export const useAccessRoles = () => {
  const { authHeader } = useAuth();
  const navigate = useNavigate();

  return useQuery(["accessRoles"], fetchAccessRoles(authHeader), {
    retry: false,
    onError: (err: any) => {
      if (err.request?.status === 500 || err.request?.status === 503) {
        navigate(ROUTE.SERVER_ERROR);
      }
      if (err.request?.status === 401) {
        navigate(ROUTE.LOGOUT);
      }
    },
  });
};
